import React, { useState } from 'react'
import { Bar, BarChart, XAxis, YAxis, Legend, Tooltip } from 'recharts'
import {
  Box,
  Tabs,
  Tab,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  IconButton,
  CircularProgress,
} from '@mui/material'
import { ArrowCircleLeft, ArrowCircleRight } from '@mui/icons-material'

const colors = [
  '#2525f0',
  '#fb00a2',
  '#12c671',
  '#ff7a2a',
  '#ff334f',
  '#ff0076',
  '#ffad04',
  '#ffd822',
]

const TABLE_PAGE_LENGTH = 7

const DataView = ({ data, taskTypes, filters, isLoadingData }) => {
  const [tab, setTab] = useState(0)
  const [tablePage, setTablePage] = useState(0)

  const getTableData = () => {
    if (data.length < TABLE_PAGE_LENGTH) return data

    const numberOfPages = Math.ceil(data.length / TABLE_PAGE_LENGTH)
    const isLast = tablePage === numberOfPages - 1

    if (isLast) return data.slice(data.length - TABLE_PAGE_LENGTH, data.length)

    return data.slice(
      TABLE_PAGE_LENGTH * tablePage,
      TABLE_PAGE_LENGTH + TABLE_PAGE_LENGTH * tablePage
    )
  }

  const tableData = getTableData()

  if (isLoadingData)
    return (
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress></CircularProgress>
      </Box>
    )

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2,
        }}
      >
        <Tabs value={tab} onChange={(_, value) => setTab(value)}>
          <Tab label={'Chart'}></Tab>
          <Tab label={'Table'}></Tab>
        </Tabs>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {tab === 0 && (
          <BarChart data={data} width={700} height={500}>
            <Tooltip
              formatter={(value, typeId) => [
                value,
                taskTypes.find((tt) => tt.id === typeId).name,
              ]}
            />
            <XAxis dataKey={'date'}></XAxis>
            <YAxis allowDecimals={false}></YAxis>
            {filters.taskTypeIds.map((tti, i) => (
              <Bar key={tti} dataKey={tti} fill={colors[i]} />
            ))}
            <Legend
              formatter={(value) => {
                return (
                  <span style={{ color: 'black' }}>
                    {taskTypes.find((tt) => tt.id === value).name}
                  </span>
                )
              }}
            />
          </BarChart>
        )}

        {tab === 1 && (
          <TableContainer sx={{ mx: 2 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>
                    <IconButton
                      disabled={tablePage <= 0}
                      onClick={() => {
                        setTablePage(tablePage - 1)
                      }}
                    >
                      <ArrowCircleLeft />
                    </IconButton>
                  </TableCell>
                  {tableData.map(({ date }) => (
                    <TableCell key={date}>{date}</TableCell>
                  ))}
                  <TableCell>
                    <IconButton
                      disabled={
                        tablePage + 1 >= data.length / TABLE_PAGE_LENGTH
                      }
                      onClick={() => {
                        setTablePage(tablePage + 1)
                      }}
                    >
                      <ArrowCircleRight />
                    </IconButton>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filters.taskTypeIds.map((id, i) => (
                  <TableRow key={id}>
                    <TableCell>
                      <span
                        style={{
                          backgroundColor: colors[i] + '66',
                          padding: 8,
                          borderRadius: 4,
                        }}
                      >
                        {taskTypes.find((tt) => tt.id === id).name}
                      </span>
                    </TableCell>
                    <TableCell></TableCell>
                    {tableData.map((item) => (
                      <TableCell key={item.date}>{item[id] || 0}</TableCell>
                    ))}
                    <TableCell></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </Box>
  )
}

export default DataView
